// THE FILE SHELLVERSIONINFO.TS IS AUTOMATICALLY GENERATED DURING BUILD PROCESS
// MANUAL CHANGES TO THIS FILE WILL BE OVERWRITTEN !!!

export const SHELL_VERSION_INFO = {
VERSION : '1.20.0',
BUILD_TS: '2024-10-29T15:09:24.858Z'
};

